import axios from 'axios';
import { getCardById } from './lifestyleOrderCards';

let lifestyleOrderSets = [];

// Fetch all lifestyle order sets from the JSON file
export const fetchLifestyleOrderSets = async () => {
  if (lifestyleOrderSets.length > 0) {
    return lifestyleOrderSets;
  }

  try {
    const response = await axios.get(`${window.location.origin}/configs/lifestyle/order_sets.json`);
    lifestyleOrderSets = response.data;
    return lifestyleOrderSets;
  } catch (error) {
    console.error('Error fetching lifestyle order sets:', error);
    return [];
  }
};

// Helper functions for order set management
export const getOrderSetById = (id, sets) => {
  return sets.find(set => set.id === id);
};

export const getOrderSetsByCategory = (category, sets) => {
  return sets.filter(set => set.category === category);
};

export const getOrderSetCards = (orderSetId, orderSets, allCards) => {
  const orderSet = getOrderSetById(orderSetId, orderSets);
  if (!orderSet) return [];
  
  return orderSet.cardIds.map(cardId => getCardById(cardId, allCards)).filter(Boolean);
};

export const searchOrderSets = (query, sets) => {
  const searchTerm = query.toLowerCase();
  return sets.filter(set => 
    set.title.toLowerCase().includes(searchTerm) ||
    set.description.toLowerCase().includes(searchTerm) ||
    set.category.toLowerCase().includes(searchTerm) ||
    set.targetConditions.some(condition => condition.toLowerCase().includes(searchTerm))
  );
};

// Get personalized recommendations based on patient data
export const getPersonalizedOrderSets = (patientData, orderSets) => {
  const recommendations = [];
  
  // Validate patient data first
  if (!patientData || !patientData.tableData || patientData.tableData.length === 0) {
    return recommendations;
  }
  
  // Example logic for personalized recommendations
  // This would integrate with actual patient health data from useHealthSnapshotData
  
  if (patientData?.systemDeviations?.cardiovascular_risk > 60) {
    recommendations.push(getOrderSetById('cardiovascular_prevention', orderSets));
  }
  
  if (patientData?.lifestyleDeviations?.emotion?.healthScore < 50) {
    recommendations.push(getOrderSetById('mental_health_support', orderSets));
  }
  
  if (patientData?.patientDemographics?.age > 65) {
    recommendations.push(getOrderSetById('longevity_optimization', orderSets));
  }
  
  return recommendations.filter(Boolean);
};

// Order set categories for organization
export const ORDER_SET_CATEGORIES = [
  'Cardiovascular Health',
  'Metabolic Health',
  'Mental Health Support',
  'Longevity & Healthspan',
  'Acute Recovery',
  'Pain Management',
  'Hormonal Health',
  'Digestive Health',
  'Immune Support',
  'Cognitive Health',
  'Detoxification',
  'Environmental Health',
  'Social & Purpose'
];

// Integration with Care360 risk calculators
export const getRiskCalculatorRecommendations = (riskScores, orderSets) => {
  const recommendations = [];
  
  // PREVENT Score integration
  if (riskScores?.preventScore > 7.5) {
    recommendations.push(getOrderSetById('cardiovascular_prevention', orderSets));
  }
  
  // Levine PhenoAge integration
  if (riskScores?.phenoAge && riskScores.phenoAge > riskScores.chronologicalAge + 5) {
    recommendations.push(getOrderSetById('longevity_optimization', orderSets));
  }
  
  return recommendations.filter(Boolean);
};
